import { globalTheme, useMixin } from '@clds/component-theme';
import { StyledSvg } from './StyledSvg';

export const DashboardIcon = () => {
  return (
    <StyledSvg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 6.66667H5.33333V0H0V6.66667ZM0 12H5.33333V8H0V12ZM6.66667 12H12V5.33333H6.66667V12ZM6.66667 0V4H12V0H6.66667Z"
        fill={useMixin(globalTheme.palette.contrastLow)}
      />
    </StyledSvg>
  );
};
